module.exports = __webpack_public_path__ + "img/icon-star-main-outline.c46e25b.svg";